<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-alert :value="error" type="error" transition="scale-transition">{{errorMessage}}</v-alert>

    <v-btn flat slot="activator" color="primary">اضافة تعليق</v-btn>
    <v-card>
      <v-card-title>
        <span class="headline">إضافة تعليق</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12>
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-textarea label="التعليق*" v-model="body" :counter="500" :rules="bodyRules"></v-textarea>
              </v-form>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" flat @click="dialog = false">إلغاء</v-btn>
        <v-btn :disabled="!valid" color="success" @click="submit">حفظ</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { Endpoint } from "../../config.js";
export default {
  props: {
    missingId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      dialog: false,
      valid: true,
      error: false,
      errorMessage: "حدث خطأ نرجو المحاولة مرة أخرى",
      body: "",
      bodyRules: [
        v => !!v || "النص مطلوب",
        v => (v && v.length <= 500) || "النص يجب أن يكون أقل من 500"
      ]
    };
  },
  methods: {
    submit() {
      var _this = this;
      axios
        .post(`${Endpoint}/api/missing/${_this.missingId}/comments`, {
          Body: this.body
        })
        .then(response => {
          _this.dialog = false;
          _this.$emit("updateComment");
          _this.$refs.form.reset();
        })
        .catch(error => {
          _this.error = true;
        });
    }
  }
};
</script>

<style scoped>
</style>
 